var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:['sidebar', ("sidebar-" + _vm.side), _vm.collapsed ? 'collapsed' : '']},[_vm._t("sidebar-header"),_c('div',{staticClass:"sidebar-content"},[_vm._t("default")],2),_vm._t("sidebar-footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }